import React from 'react'
import HeroSection from '../components/HomePage/HeroSection'
import OurServices from '../components/HomePage/OurServices'
import WhyChooseParam from '../components/WhyChooseParam'

const Home = () => {
    return (
        <>
            <HeroSection />
            <OurServices />
            <WhyChooseParam />
            
        </>
    )
}

export default Home